import React from "react"
import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"
import useRibbonHeight from "../../hooks/useRibbonHeight"

const Mobilespacer = styled(Flex)`
  background: transparent;
`

const MobileNavSpacer = ({ nextReward }) => {
  const height = useRibbonHeight()
  const hasNextReward = nextReward?.segment_name

  // if hasNextReward avail instead of  promo ribbon  we show blue loyalty ribbon 32px

  const className = ["hide-lg-up", "mobile-nav-spacer"].join(" ")

  return (
    <Mobilespacer
      className={className}
      style={{ height: hasNextReward ? 32 : height + "px" }}
    />
  )
}

export default MobileNavSpacer
